import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark text-white pt-16 pb-8" data-id="element-78">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-79">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-80">
          <div className="col-span-1 md:col-span-1" data-id="element-81">
            <div className="mb-4" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/oG2uuGYn8jU9LyVa8StNpR/Logo_Cava_Transparent.png" alt="De Rien Financial Services" className="h-14 w-auto brightness-0 invert" data-id="element-83" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-84">
              Fast, reliable, and convenient financial solutions in Botswana.
              Helping you achieve your dreams with ethical finance.
            </p>
            <div className="flex space-x-4" data-id="element-85">
              <a href="#" className="text-gray-400 hover:text-gold transition-colors" data-id="element-86">
                <Facebook size={20} data-id="element-87" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold transition-colors" data-id="element-88">
                <Twitter size={20} data-id="element-89" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold transition-colors" data-id="element-90">
                <Instagram size={20} data-id="element-91" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold transition-colors" data-id="element-92">
                <Linkedin size={20} data-id="element-93" />
              </a>
            </div>
          </div>

          <div data-id="element-94">
            <h4 className="font-bold text-lg mb-4 text-white" data-id="element-95">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-96">
              <li data-id="element-97">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-98">
                  Home
                </a>
              </li>
              <li data-id="element-99">
                <a href="#about" className="hover:text-gold transition-colors" data-id="element-100">
                  About Us
                </a>
              </li>
              <li data-id="element-101">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-102">
                  Our Services
                </a>
              </li>
              <li data-id="element-103">
                <a href="#process" className="hover:text-gold transition-colors" data-id="element-104">
                  Loan Process
                </a>
              </li>
              <li data-id="element-105">
                <a href="#contact" className="hover:text-gold transition-colors" data-id="element-106">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-107">
            <h4 className="font-bold text-lg mb-4 text-white" data-id="element-108">Services</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-109">
              <li data-id="element-110">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-111">
                  Personal Loans
                </a>
              </li>
              <li data-id="element-112">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-113">
                  Business Loans
                </a>
              </li>
              <li data-id="element-114">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-115">
                  Debt Consolidation
                </a>
              </li>
              <li data-id="element-116">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-117">
                  Top-Up Loans
                </a>
              </li>
              <li data-id="element-118">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-119">
                  Micro Loans
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-120">
            <h4 className="font-bold text-lg mb-4 text-white" data-id="element-121">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-122">
              <li data-id="element-123">
                <a href="#privacy" className="hover:text-gold transition-colors" data-id="element-124">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-125">
                <a href="#terms" className="hover:text-gold transition-colors" data-id="element-126">
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-127">
                <a href="#disclaimer" className="hover:text-gold transition-colors" data-id="element-128">
                  Disclaimer
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-sm text-gray-500" data-id="element-129">
          <p data-id="element-130">
            &copy; {new Date().getFullYear()} De Rien Cash Loan. All rights
            reserved.
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-131">
            Designed by{' '}
            <span className="text-gold font-medium" data-id="element-132">Eimaginary</span>
          </p>
        </div>
      </div>
    </footer>;
}